@if (tariffs$ | async; as tariffs) {
  @if (isToggleAvailable) {
    <h1 class="title" translate="register-account.title.choose"></h1>
    @if (isIslamicCountry || isSwapFreeAvailable) {
      <p
        class="sub-title"
        [translate]="isIslamicCountry ? 'register-account.title-sub.islamic' : 'register-account.title-sub.swapfree'">
      </p>
    }
    <div class="margin-card m-bottom">
      <div class="buttons-split">
        <button
          data-qa="account-opening.real-button"
          routerLink="../real"
          queryParamsHandling="merge"
          routerLinkActive="active"
          class="button-border buttons-split__item"
          >
          <span translate="open-account.label.real"></span>
        </button>
        <button
          data-e2e-element="account-create.tabs.demo"
          data-qa="account-opening.demo-button"
          routerLink="../demo"
          queryParamsHandling="merge"
          routerLinkActive="active"
          class="button-border buttons-split__item"
          >
          <span translate="open-account.label.demo"></span>
        </button>
      </div>
    </div>
  }
  <div class="acc-types">
    @for (tariff of tariffs; track tariff) {
      <pac-account-card
        (selectTariff)="selectTariff(tariff.type)"
        [tariff]="tariff"
      ></pac-account-card>
    }
  </div>
} @else {
  <app-loader class="compact" [isInner]="true">
    <div class="loader-desk" translate="register-account.label.loading-accounts"></div>
  </app-loader>
}

